import React, {useRef, useState} from "react";
import {usePublicTagList} from "../../hooks/usePublicEndpoint";
import {Alert, Button, Figure, InputGroup, Form, Offcanvas, Badge, OverlayTrigger, Tooltip} from "react-bootstrap";
import {MenuBar, MenuOrderBy, MenuSearchTerm, OurClearAlert, OurPagination2, ProductCardLoading} from "../_components";
import {useFilterParam, useLocalFilter2, useProductFilteredList, useProductOrderOptions, useWindowSize} from "../../hooks";
import {useBasket} from "./useShop";
import {useAlert, useAuth, useDarkMode} from "../../context";
import {Link, useSearchParams} from "react-router-dom";
import {scrollToTop, config} from "../../utils2";
import {isDateInCurrentWeek} from "../backend2/admin/utilities/readableDate";
import {UserPrice} from "./_components/UserPrice";

export function ProductList() {
    const {value: tagList, loadingValue: tagLoading, errorValue: tagError, clearError: tagErrorClear} = usePublicTagList()
    const {list: productList, loadingList, errorList, clearErrorList} = useProductFilteredList()
    const {orderOptions, errorOrderOptions, clearErrorOrderOptions} = useProductOrderOptions()

    // Filter
    const filteredList = useLocalFilter2(productList, ["title"])

    const [tagIds, setTagIds] = useFilterParam("tags")

    function handleClick(id) {
        const currentTags = tagIds ? tagIds.split("_") : []

        const updatedTags = currentTags.includes(id)
            ? currentTags.filter(tag => tag !== id)
            : [...currentTags, id]

        setTagIds(updatedTags.join("_"))
    }

    function handleSelectAll() {
        setTagIds(null)
    }

    return <div className="mx-2 mx-sm-0">
        <OurClearAlert variant="danger" msg={errorOrderOptions} onClear={clearErrorOrderOptions}/>
        <OurClearAlert variant="danger" msg={errorList} onClear={clearErrorList}/>
        <OurClearAlert variant="danger" msg={tagError} onClear={tagErrorClear}/>

        {/*<ShopPageTitle title="Shop Products" className="mt-2"/>*/}

        <div className="mt-2"/>
        <MenuBar>
            <Button className="flex-shrink-0 d-none d-md-block" variant={tagIds ? "outline-success" : "success"} onClick={handleSelectAll}>
                <span className="">All Products</span>
                {/*<span className="d-md-none">All</span>*/}
            </Button>
            {/*<div className="d-flex ms-auto">*/}
            <MenuSearchTerm/>
            {/*</div>*/}
            <MenuOrderBy orderOptions={orderOptions}/>
            <FilterOffCanvas/>
        </MenuBar>

        {/*<div className="mt-2">Filter by tags to discover products:</div>*/}
        <div className="d-flex flex-wrap align-items-center gap-2">
            <Button className="d-md-none" variant={tagIds ? "outline-success" : "success"} onClick={handleSelectAll} size="sm">All Products</Button>

            {tagList.map(tag => <Button key={tag.id} className="" variant={tagIds?.split("_").includes(tag.id) ? "primary" : "outline-secondary"}
                                        onClick={() => handleClick(tag.id)} size="sm">{tag.name}</Button>)}
        </div>

        <ProductCardLoading show={loadingList || tagLoading}/>

        <div className="d-flex justify-content-evenly flex-wrap gap-2 mt-2">
            {productList.length > 0 ?
                filteredList.map(product => (
                    // <div key={product.id} className="col-12 col-sm-5 col-md-4 col-lg-3 col-xl-2">
                    <div key={product.id} className="d-flex my-2">
                        <RenderFilteredProducts product={product}/>
                    </div>
                )) :
                (
                    <div>No products match your selected filters.</div>
                )}
        </div>

        <OurPagination2 loading={loadingList || tagLoading} itemCount={productList.length}/>
    </div>
}

function RenderFilteredProducts({product}) {
    const {addArticle, errorArticle, loadingArticle, clearErrorArticle} = useBasket(false)
    const {success} = useAlert()
    const {darkMode} = useDarkMode()
    const {user} = useAuth()

    const {width} = useWindowSize()

    function handleSubmit(prodId, title) {
        addArticle(prodId, 1)
            .then(() => {
                success(<span><strong>{title}</strong> has been added to your <Alert.Link as={Link} to="/shop/cart">Cart</Alert.Link>!</span>)
                scrollToTop()
            })
            .catch(console.warn)
    }

    const cardWidth = "220px"
    const cardHeight = width < 576 ? "100%" : "300px"

    return <>

        <OurClearAlert variant="danger" msg={errorArticle} onClear={clearErrorArticle}/>

        {/*<div className="d-flex flex-column p-1"*/}
        {/*     style={{*/}
        {/*         width: '100%',*/}
        {/*         height: width < 576 ? '' : '310px',*/}
        {/*         overflow: 'hidden'*/}
        {/*     }}*/}
        {/*>*/}
        <div
            className="card border-0 "
            style={{width: cardWidth, height: cardHeight, overflow: 'hidden'}}
        >

            <div className="mb-0">
                {isDateInCurrentWeek(product.created_at) ? <Badge bg="info" pill>New</Badge> :
                    <Badge bg="transparent" pill style={{display: 'inline-block', width: 'auto', height: 'auto'}}></Badge>}
                {/*<Badge bg="danger" pill>Promo</Badge>*/}
            </div>

            <Figure className="d-flex justify-content-center">
                <Link to={`/shop/detail/${product.id}`}>
                    <Figure.Image
                        src={config.get_public_media(product.medias[0].path, "thumb", darkMode)}
                        alt={product.title}
                        rounded
                        height="150px"
                        width="150px"
                        loading="lazy"
                    />
                </Link>
            </Figure>

            <Link to={`/shop/detail/${product.id}`}
                  className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                <span className="d-block text-wrap fw-medium">{product.title}</span>
            </Link>

            <div className="d-flex flex-column mt-auto">
                <div className="d-flex justify-content-between">
                    {/*<div className="fw-medium fs-4">€ {product.unit_price}</div>*/}
                    <UserPrice unitPrice={product.unit_price} vat={user?.vat_percentage}/>
                    {product.stock > 0 && <OverlayTrigger placement="top" overlay={<Tooltip>In stock</Tooltip>}>
                        <Button variant="success" className="" onClick={() => handleSubmit(product.id, product.title)} disabled={loadingArticle}>
                            {loadingArticle ? <i className="bi bi-three-dots"/> : <i className="bi bi-cart-plus"/>}
                        </Button>
                    </OverlayTrigger>}

                    {product.stock === 0 && product.is_available &&
                        <OverlayTrigger placement="top" overlay={<Tooltip>Backorder</Tooltip>}>
                            <Button variant="warning" className="" onClick={() => handleSubmit(product.id, product.title)} disabled={loadingArticle}>
                                {loadingArticle ? <i className="bi bi-three-dots"/> : <i className="bi bi-cart-plus"/>}
                            </Button>
                        </OverlayTrigger>}

                    {product.stock === 0 && !product.is_available && <OverlayTrigger placement="top" overlay={<Tooltip>Out of stock</Tooltip>}>
                        <span><Button variant="success" disabled><i className="bi bi-cart-plus"/></Button></span>
                    </OverlayTrigger>
                    }
                </div>
            </div>
        </div>
    </>
}

function FilterOffCanvas() {
    const [show, setShow] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams()
    const [priceFrom, setPriceFrom] = useState(searchParams.get("price_from") || "")
    const [priceTo, setPriceTo] = useState(searchParams.get("price_to") || "")
    const [inStock, setInStock] = useState(searchParams.get("in_stock") === "true")

    const applyButtonRef = useRef(null);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    function handleApply() {

        const newParams = new URLSearchParams(searchParams);
        if (priceFrom) {
            newParams.set("price_from", priceFrom)
        } else {
            newParams.delete("price_from")
        }

        if (priceTo) {
            newParams.set("price_to", priceTo)
        } else {
            newParams.delete("price_to")
        }

        if (inStock) {
            newParams.set("in_stock", "true")
        } else {
            newParams.delete("in_stock")
        }

        setSearchParams(newParams, {replace: true}); // Updates the URL with new filters
        handleClose();
    }

    function handleClear() {
        setPriceFrom("")
        setPriceTo("")
        setInStock(false)
        const newParams = new URLSearchParams(searchParams);
        newParams.delete("price_from")
        newParams.delete("price_to")
        newParams.delete("in_stock")
        setSearchParams(newParams, {replace: true})
        handleClose()
    }

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            applyButtonRef.current?.click();
        }
    };

    return (
        <>
            <Button variant="primary" onClick={handleShow}>
                <span className="d-none d-sm-inline">Filter</span>
                <i className="bi bi-sliders2 d-sm-none"/>
            </Button>

            <Offcanvas show={show} onHide={handleClose} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Filters</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>

                    <div>Price:</div>
                    <div className="d-flex align-items-center gap-2">
                        <InputGroup>
                            <Form.Control type="number" value={priceFrom} placeholder="Price from" onChange={e => setPriceFrom(e.target.value)}
                                          onKeyDown={handleKeyDown}/>
                            <InputGroup.Text>€</InputGroup.Text>
                        </InputGroup>
                        <div>-</div>
                        <InputGroup>
                            <Form.Control type="number" value={priceTo} placeholder="Price to" onChange={e => setPriceTo(e.target.value)} onKeyDown={handleKeyDown}/>
                            <InputGroup.Text>€</InputGroup.Text>
                        </InputGroup>
                    </div>

                    <Form className="my-3">
                        <Form.Check
                            type="switch"
                            id="custom-switch"
                            label="Only in Stock"
                            checked={inStock}
                            onChange={e => setInStock(e.target.checked)}
                            onKeyDown={handleKeyDown}
                        />
                    </Form>

                    <div className="d-flex justify-content-end gap-2">
                        <Button variant="outline-secondary" className="my-2" onClick={handleClear}>Clear</Button>
                        <Button ref={applyButtonRef} variant="primary" className="my-2" onClick={handleApply}>Apply</Button>
                    </div>

                </Offcanvas.Body>

            </Offcanvas>
        </>
    )
}